/* =========================================================
   EAZY CLOTHES — JS BAZOWY
   Etap 1. Struktura: jeden modul = jedna nazwana funkcja IIFE.
   Bez localStorage/sessionStorage. Bez wlasnego kursora.
   Nic tu nie dotyka koszyka, wariantow ani checkoutu.
   ========================================================= */

/* ---------------------------------------------------------
   MODUL: odslanianie przy scrollu
   Nadaje .is-visible elementom .ez-reveal, gdy wejda w viewport.
   Przy prefers-reduced-motion odslania wszystko od razu i nie
   uruchamia obserwatora.
   --------------------------------------------------------- */
(function ezRevealOnScroll() {
  const SELECTOR = '.ez-reveal';

  const revealAll = (nodes) => {
    nodes.forEach((node) => node.classList.add('is-visible'));
  };

  const init = () => {
    const nodes = Array.from(document.querySelectorAll(SELECTOR));
    if (nodes.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      revealAll(nodes);
      return;
    }

    const reveal = (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    };

    /* Dolny margines -10% sprawia, ze sekcja odslania sie chwile po
       wejsciu w kadr, a nie dokladnie na krawedzi. Dla tresci, ktora jest
       na ekranie juz przy otwarciu strony, dzialalo to odwrotnie:
       odnosnik hero lezy nisko w oknie, nigdy nie trafial w pole
       obserwatora i zostawal na opacity 0 az do przewiniecia — czyli
       glowne wezwanie strony bylo niewidoczne w chwili wejscia.

       Dlatego pierwszy ekran obsluguje osobny obserwator, bez marginesu.
       Ta sama sciezka, to samo opoznienie kaskadowe, tylko granica jest
       zwykla krawedzia okna. */
    const scrollObserver = new IntersectionObserver(reveal, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.05,
    });

    const firstScreenObserver = new IntersectionObserver(reveal, { threshold: 0.05 });

    nodes.forEach((node) => {
      const isOnFirstScreen = node.getBoundingClientRect().top < window.innerHeight;
      const observer = isOnFirstScreen ? firstScreenObserver : scrollObserver;
      observer.observe(node);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* ---------------------------------------------------------
   MODUL: stan naglowka po przewinieciu
   Ustawia klase .ez-scrolled na <body>, ktora zageszcza naglowek
   i wlacza pasek z rozmyciem. Odczyt pozycji w rAF, zeby nie
   liczyc stylu na kazdym zdarzeniu scroll.
   --------------------------------------------------------- */
(function ezHeaderScrollState() {
  const THRESHOLD = 24;
  const body = document.body;
  let ticking = false;
  let isScrolled = false;

  const update = () => {
    ticking = false;
    const shouldBeScrolled = window.scrollY > THRESHOLD;
    if (shouldBeScrolled === isScrolled) return;
    isScrolled = shouldBeScrolled;
    body.classList.toggle('ez-scrolled', isScrolled);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
